import { DateTime } from 'luxon';

import { ImagePerDayApi } from '../../api/models/image-per-day-api';

export class ImagePerDay {
    public host: string;
    public date: string;
    public count: number;

    public static mapperFromApi(source: ImagePerDayApi): ImagePerDay {
        const target = new ImagePerDay();

        target.host = source.host;
        target.date = source.date;
        target.count = source.count;

        return target;
    }
}

export interface HostDailySeries {
    host: string;
    /** ISO date strings (YYYY-MM-DD) sorted ascending */
    dates: string[];
    counts: number[];
}
